import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { GameStore } from '@gamiphy/loyalty-station-desktop/store/game';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { useTranslation } from '@gamiphy/react-i18n';
import { compact } from '@gamiphy/utils/array';
import React from 'react';
import { Tabs } from '@gamiphy/loyalty-station-desktop/store/ui';
import gameSvg from './assets/game.svg';
import homeSvg from './assets/home.svg';
import levelsSvg from './assets/levels.svg';
import missionsSvg from './assets/missions.svg';
import redeemSvg from './assets/redeem.svg';
import { TabInfo } from './types';

export const useTabs = (): TabInfo[] => {
  const { t } = useTranslation();
  return React.useMemo<TabInfo[]>(() => {
    if (AppStore.isCashbackProgram) {
      return [
        {
          title: t('home.tab', { defaultValue: 'Home' }),
          icon: ThemeStore.getSvgUrl('homeTab', homeSvg),
        },
      ];
    }
    return compact([
      {
        tab: Tabs.Missions,
        title: t('home.tab', { defaultValue: 'Home' }),
        icon: ThemeStore.getSvgUrl('homeTab', homeSvg),
      },
      UserStore.isRealUser && {
        tab: Tabs.Missions,
        title: t('shared.missions', { defaultValue: 'Missions' }),
        icon: ThemeStore.getSvgUrl('missionsTab', missionsSvg),
      },
      GameStore.isGameEnabled && {
        tab: Tabs.Game,
        title: t('game.tab', { defaultValue: 'Game' }),
        icon: ThemeStore.getSvgUrl('gameTab', gameSvg),
      },
      UserStore.isRealUser && {
        tab: Tabs.Redeem,
        title: t('shared.redeem', { defaultValue: 'Redeem' }),
        icon: ThemeStore.getSvgUrl('redeemTab', redeemSvg),
      },
      UserStore.isRealUser && {
        tab: Tabs.Levels,
        title: t('levels.tab', { defaultValue: 'Levels' }),
        icon: ThemeStore.getSvgUrl('levelsTab', levelsSvg),
      },
    ]);
  }, [t, UserStore.isRealUser,
    GameStore.isGameEnabled,
    AppStore.isCashbackProgram]);
};
